import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class RadioGroup extends React.PureComponent {
	constructor(props) {
		super(props);

		this.handleClickRadioInput = this.handleClickRadioInput.bind(this);
	}

	render() {
		return (
			<fieldset className='RadioGroup form-group'>
				{this.props.label ? <legend className='col-form-label pt-0'>{this.props.label}</legend> : ""}

				<div className={classNames('form-control', {'is-invalid': this.props.touched && this.props.invalidFeedback})}>

					{this.props.options.map((optionObject) =>
						<div className='form-check form-check-inline' key={optionObject.value}>
							<input type='radio'
								className='form-check-input'
								id={this.props.name + optionObject.value}
								value={optionObject.value}
								onChange={this.handleClickRadioInput}
								name={this.props.name}
								checked={this.props.value === optionObject.value ? true : false}
							/>
							<label className='form-check-label' htmlFor={this.props.name + optionObject.value}>{optionObject.label}</label>
						</div>
					)}
				</div>

				{this.props.touched && this.props.invalidFeedback &&
					<div className='invalid-feedback'>
						{this.props.invalidFeedback}
					</div>
				}
			</fieldset>
		);
	}

	handleClickRadioInput(e) {
		this.props.onChangeCallback(e);
	}
}

RadioGroup.propTypes = {
	onChangeCallback: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired
		})
	),
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.string,
	touched: PropTypes.bool.isRequired,
	invalidFeedback: PropTypes.string
};

RadioGroup.defaultProps = {
	onChangeCallback: () => {}
};

export default RadioGroup;
